import React, {useContext} from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
    CartesianGrid
} from 'recharts';
import { ThemeContext } from '../../context/ThemeContext';


const LineChartComponent = ({data}) => {
    const { isDarkMode } = useContext(ThemeContext);

    const colors = !isDarkMode ? ["#C2000F","#5D8F15"]:["#F95E64","#62A575"];

    return (
        <ResponsiveContainer width="100%" height={200}>
            <LineChart data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="week" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="incoming_tickets" stroke={colors[0]} activeDot={{ r: 8 }} />
                <Line type="monotone" dataKey="closed_tickets" stroke={colors[1]} />
            </LineChart>
        </ResponsiveContainer>
    );
};

export default LineChartComponent;
